import { faArrowDownToBracket } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DropdownMenu } from '@nexelem/components';
import { useTableTranslation } from '../translations';
import { useExportToCsv } from './useExportToCsv';

type ExportToCsvButtonProps = {
  fileName: string;
};

export const ExportToCsvButton = ({ fileName }: ExportToCsvButtonProps) => {
  const { t } = useTableTranslation();
  const { exportToCsv, isExporting } = useExportToCsv({ fileName });

  return (
    <DropdownMenu.Button
      className="border-t border-border-secondary"
      isLoading={isExporting}
      StartIcon={<FontAwesomeIcon icon={faArrowDownToBracket} />}
      onClick={() => exportToCsv()}
    >
      {t('exportToCsv')}
    </DropdownMenu.Button>
  );
};
